import React from "react";
import PageTitleAndSnackBar from "../../components/common/PageTitleAndSnackBar";
import AddInventory from "../../components/inventory/AddInventory";
import ListInventory from "../../components/inventory/ListInventory";
import { useParams } from "react-router-dom";
import BulkInventoryUpload from "../../components/inventory/BulkInventoryUpload";

const Inventory = () => {
  let { method } = useParams();

  return (
    <>
      {/* list and add render their own title + breadcrumb header */}
      {method == "bulkupload" && <PageTitleAndSnackBar pageTitle={"Inventory"} />}

      {method == "add" && <AddInventory />}
      {method == "list" && <ListInventory />}
      {method == "bulkupload" && <BulkInventoryUpload />}
    </>
  );
};

export default Inventory;
